module.exports = __webpack_public_path__ + "static/media/84.272de9d0.jpg";